import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  Grid,
} from '@mui/material';
import { Launch, ArrowBack } from '@mui/icons-material';

const TourneyPlannerPage = () => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#fafafa', pt: 8 }}>
      <Container maxWidth="lg">
        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h3" gutterBottom color="primary">
            TourneyPlanner
          </Typography>
          <Typography variant="h6" color="secondary" gutterBottom>
            Complete Wrestling Tournament Management System
          </Typography>
          <Typography variant="body1" paragraph>
            TourneyPlanner is your comprehensive solution for wrestling tournament organization. From team registration to bracket generation and scheduling, we've got you covered.
          </Typography>
          
          <Grid container spacing={4} sx={{ mt: 4 }}>
            <Grid item xs={12} md={6}>
              <Typography variant="h5" gutterBottom color="secondary">
                Key Features
              </Typography>
              <Box component="ul" sx={{ pl: 2 }}>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                  CSV wrestler import with flexible column mapping
                </Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                  Automatic weight class generation and grouping
                </Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                  Bracket creation for 2, 3, and 4+ competitors
                </Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                  Multi-mat scheduling with bout numbering
                </Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                  Printable brackets and schedules
                </Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                  Team and wrestler management
                </Typography>
              </Box>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Typography variant="h5" gutterBottom color="secondary">
                Perfect For
              </Typography>
              <Box component="ul" sx={{ pl: 2 }}>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                  High school wrestling tournaments
                </Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                  Youth wrestling events
                </Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                  Club wrestling competitions
                </Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                  Multi-school tournaments
                </Typography>
              </Box>
            </Grid>
          </Grid>
          
          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              endIcon={<Launch />}
              href="/tourney-planner/app"
              sx={{ mr: 2 }}
            >
              Launch TourneyPlanner
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<ArrowBack />}
              href="/"
            >
              Back to Home
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default TourneyPlannerPage;
